<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="ml-3">
        Relatório {{ type }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Relatório {{ type }}</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="filter.dataInicialString"
              v-mask="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="filter.dataFinalString"
              v-mask="'##/##/####'"
              label="Data de Término"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-city-combobox :filter="filter"></app-city-combobox>
          </v-col>
          <v-col>
            <app-group-solution-combobox
              :filter="filter"
              @changeGroupSolution="(e) => (filter.grupoSolucaoIds = e)"
            ></app-group-solution-combobox>
          </v-col>

          <v-col>
            <app-consultant-combobox :filter="filter"></app-consultant-combobox>
          </v-col>
        </v-row>
        <v-row v-if="this.$store.state.uf === 'MA'">
          <v-col>
            <app-project-combobox :filter="filter"></app-project-combobox>
          </v-col>
        </v-row>
        <v-row v-if="type == 'Geral'">
          <v-col
            v-if="
              isFullAdmin ||
              (config.incluirObsevacoes && groupsConfig.incluirObsevacoes)
            "
          >
            <v-checkbox
              v-model="filter.observacoes"
              id="sensibilizacao"
              color="primary"
              label=" Incluir Observações"
            />
          </v-col>
          <v-col
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
          >
            <v-checkbox
              v-model="filter.relatoriosadministrativos"
              id="sensibilizacao"
              color="primary"
              label=" Incluir Relatórios Administrativos"
            />
          </v-col>
          <v-col
            v-if="
              isFullAdmin ||
              (config.verParcialAcaoFinalizada &&
                groupsConfig.verParcialAcaoFinalizada)
            "
          >
            <v-checkbox
              v-model="filter.acoesfinalizadas"
              id="sensibilizacao"
              color="primary"
              label="Apenas relatórios de Ações finalizadas"
            />
          </v-col>
        </v-row>
        <!--
        <v-row>
          <v-col>
            <v-text-field
              v-model="filter.responsavelMunicipio"
              label="Responsável do Município"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="filter.observacoes"
              label="Observações e Comentários"
            ></v-textarea>
          </v-col>
        </v-row>
        -->
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="download()">Baixar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reportAPI } from "@/modules/report/API/ReportAPI";
import { AppConsultantCombobox } from "@/modules/user";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppProjectCombobox } from "@/modules/project";
import { AppCityCombobox } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalReportGlobal",
  props: {
    type: { type: String, default: "Global" },

    // municipioId: { required: true }
  },
  computed: {
    ...mapGetters(["city", "isFullAdmin"]),
  },
  components: {
    AppCityCombobox,
    AppProjectCombobox,
    AppConsultantCombobox,
    AppGroupSolutionCombobox,
  },
  data() {
    return {
      dialog: false,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),

      filter: {
        municipioId: this.municipioId,
        municipio: null,
        dataInicialString: "",
        dataFinalString: "",
        observacoes: "",
        responsavelMunicipio: "",
        nome: "",
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    download() {
      this.setLoading(true);
      // this.filter.nome = this.city
      this.filter.ProjetoIdString = this.filter.projetoId;
      this.filter.GrupoSolucaoIdString = this.filter.grupoSolucaoIds;

      this.filter.UsuarioIdString = this.filter.usuarioId;
      this.filter.MunicipioIdString = null;
      this.filter.nome = "";
      if (this.filter.grupoSolucaoIds === null) {
        this.filter.grupoSolucaoIds = 0;
      }
      if (this.filter.municipio !== null) {
        this.filter.MunicipioIdString = "0";
        this.filter.nome = "";
        for (var i = 0; i < this.filter.municipio.length; i++) {
          this.filter.MunicipioIdString =
            this.filter.MunicipioIdString +
            "," +
            this.filter.municipio[i].municipioId;
          this.filter.nome =
            this.filter.nome + this.filter.municipio[i].nome + " | ";
        }
        // this.filter.MunicipioId = this.filter.municipio[0].municipioId
      }

      if (this.type == "Global")
        reportAPI
          .getReportGlobal(this.filter)
          .then((resp) => {
            let blob = new Blob([resp.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Relatorio Global.pdf";
            link.click();
            this.setLoading(false);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter relatório");
          });
      else
        reportAPI
          .getReportGeral(this.filter)
          .then((resp) => {
            let blob = new Blob([resp.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Relatório Geral.pdf";
            link.click();
            this.setLoading(false);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter relatório");
          });
    },
  },
};
</script>
